import {createSvgIcon} from "@mui/material";

export const CheckMarkIcon = createSvgIcon(
    <svg width="24" height="24" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <polyline
          fill="none"
          stroke="#1ec646"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          points="2.98 28.69 14.24 38.94 44.92 9.3"
      />
    </svg>,
    'CheckMark'
)

